<template>
  <div class="first-book-workspace">
    <FirstBookDailyReviewPanel @first-book-changed="handleFirstBookChanged" />
    <FirstBookHistoryCoveragePanel
      ref="historyCoverage"
      @scope-updated="handleScopeUpdated"
    />

    <el-card shadow="never" class="member-entry-card">
      <div class="member-entry-content">
        <div>
          <strong>第一本账成员管理</strong>
          <p v-if="scopeReady">
            当前正式区 {{ analysisScope.formal_count || 0 }} 只、临时区 {{ analysisScope.temp_count || 0 }} 只，合计 {{ analysisScope.stock_total_count || 0 }} 只。
          </p>
          <p v-else>成员真值正在确认，确认完成前不显示为 0。</p>
        </div>
        <el-button
          v-if="scopeReady"
          size="small"
          type="primary"
          plain
          @click="toggleManagement"
        >{{ managementOpen ? '收起成员管理' : '打开成员管理' }}</el-button>
        <el-tag v-else type="info" size="small">状态待确认</el-tag>
      </div>
    </el-card>

    <FirstBookSemantics
      v-if="managementOpen && scopeReady"
      ref="semantics"
      class="member-management"
    />
  </div>
</template>

<script>
import FirstBookDailyReviewPanel from '@/components/FirstBookDailyReviewPanel.vue'
import FirstBookHistoryCoveragePanel from '@/components/FirstBookHistoryCoveragePanel.vue'
import FirstBookSemantics from '@/views/FirstBookSemantics.vue'

export default {
  name: 'FirstBookWorkspace',
  components: {
    FirstBookDailyReviewPanel,
    FirstBookHistoryCoveragePanel,
    FirstBookSemantics
  },
  data() {
    return {
      analysisScope: {},
      managementOpen: false
    }
  },
  computed: {
    scopeReady() {
      return Boolean(
        this.analysisScope &&
        Number(this.analysisScope.stock_total_count) >= 0 &&
        Array.isArray(this.analysisScope.items)
      )
    }
  },
  methods: {
    handleScopeUpdated(scope) {
      this.analysisScope = scope && typeof scope === 'object' ? { ...scope } : {}
      if (!this.scopeReady) this.managementOpen = false
    },
    toggleManagement() {
      this.managementOpen = !this.managementOpen
    },
    handleFirstBookChanged() {
      if (this.$refs.historyCoverage && this.$refs.historyCoverage.refreshData) {
        this.$refs.historyCoverage.refreshData()
      }
      if (this.managementOpen && this.$refs.semantics && this.$refs.semantics.refreshData) {
        this.$refs.semantics.refreshData()
      }
    }
  }
}
</script>

<style scoped>
.first-book-workspace { width: 100%; }
.member-entry-card { margin: 0 0 16px; border-radius: 14px; border-color: #dfe7f2; }
.member-entry-content { display: flex; align-items: center; justify-content: space-between; gap: 18px; }
.member-entry-content strong { color: #0f172a; font-size: 15px; }
.member-entry-content p { margin: 6px 0 0; color: #64748b; font-size: 12px; line-height: 1.6; }
.member-management { margin-top: 2px; }
@media (max-width: 760px) {
  .member-entry-content { align-items: flex-start; flex-direction: column; }
}
</style>
